module.exports = __webpack_public_path__ + "img/img3.be32e34d.png";